export default "__VITE_ASSET__DIve5jDA__"